import type { Appointments } from "@/lib/appointments"
import { mergeAppointmentResults } from "@/lib/appointments/mergeResults"
import type { BookingSearch } from "@/lib/bookingSearch"
import { Mirror } from "@/lib/mirror"
import { isSameTime } from "@/lib/time/isSame"

export const buildAppointmentOfferings = ({
  businesses,
  practiceId,
  startTime,
}: {
  businesses: BookingSearch.BusinessMirror
  practiceId: string
  startTime: string
}): Mirror<Appointments.Offering> => {
  const appointmentResults = businesses.collection[
    practiceId
  ].relationships.available_appointments.data.filter((availableAppointment) => {
    return isSameTime(startTime, availableAppointment.attributes.start_time)
  })

  const offerings = appointmentResults.reduce(
    (collection, appointmentResult) => {
      const appointmentType = appointmentResult.attributes.appointment_type.data

      return {
        ...collection,
        [appointmentType.id]: {
          id: appointmentType.id,
          appointmentType,
          appointments: mergeAppointmentResults({
            appointmentResult,
            existingAppointmentResults:
              collection[appointmentType.id]?.appointments,
          }),
        },
      }
    },
    {} as Mirror.Collection<Appointments.Offering>
  )

  return Mirror.build(offerings)
}
